import script from "./policyEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./policyEdit.vue?vue&type=script&setup=true&lang=js"

import "./policyEdit.vue?vue&type=style&index=0&id=aff405c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aff405c4"]])

export default __exports__